var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRankingArrow = function SvgRankingArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.566 1.26A.762.762 0 0 0 13 1a.762.762 0 0 0-.566.26L7.395 6.854 2.357 1.26a.746.746 0 0 0-.768-.218.85.85 0 0 0-.56.623.96.96 0 0 0 .196.852L6.829 8.74c.15.166.354.26.566.26a.762.762 0 0 0 .566-.26l5.605-6.223a.94.94 0 0 0 .234-.628.94.94 0 0 0-.234-.629Z",
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.4
  })));
};
export default SvgRankingArrow;